import { currencyFormat } from '@/helpers/stringHelpers';
import OrderItemRow from '@/app/orderItem/OrderItemRow';
import OrderTenderView from '@/app/orderTender/OrderTenderView';

import { Card } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow,
  TableCell
} from '@/components/ui/table';

import { useOrder } from '@/data/order';

const OrderView = ({ orderId }) => {
  const order = useOrder(orderId);

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Item</TableHead>
              <TableHead>Pro</TableHead>
              <TableHead>Date</TableHead>
              <TableHead className="text-right">Price</TableHead>
              <TableHead className="text-right">Total</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {order.data.items.map((orderItem) => (
              <OrderItemRow orderItem={orderItem} key={orderItem.id} />
            ))}
            <TableRow>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell>
                <div className="text-right">
                  <span>Subtotal</span>
                </div>
              </TableCell>
              <TableCell>
                <div className="text-right">
                  <span>{currencyFormat(order.data.subTotal)}</span>
                </div>
              </TableCell>
            </TableRow>
            {order.data.taxSummary.map((tax) => (
              <TableRow key={tax.label}>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell>
                  <div className="text-right">
                    <span>
                      {tax.label} {tax.rate / 100}%
                    </span>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="text-right">
                    <span>{currencyFormat(tax.totalAmount)}</span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell>
                <div className="text-right">
                  <span className="font-bold">Total</span>
                </div>
              </TableCell>
              <TableCell>
                <div className="text-right">
                  <span className="font-bold">
                    {currencyFormat(order.data.total)}
                  </span>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
      <div className="py-8">
        <h2 className="text-lg mb-6 font-medium">Payment</h2>
        <div className="flex justify-end">
          {order.data.tenders.map((tender) => (
            <OrderTenderView tender={tender} key={tender.id} />
          ))}
        </div>
      </div>
    </>
  );
};

export default OrderView;
